module.exports = __webpack_public_path__ + "static/media/Digit_meter.8a5166f7.jpg";